import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Page from "./Page";
import EntityList from "./EntityList";
import RetailerModal from "../modals/RetailerModal";
import Filter from "../ui/Filter";
import Pagination from "../elements/Pagination";

import useEntity from "../../hooks/useEntity";

const Retailers = () => {
  const navigate = useNavigate();

  const [openRetailerModal, setOpenRetailerModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [filter, setFilter] = useState(null);

  const {
    getPage,
    setEntity,
    entityName,
    entityList,
    entitySchema,
    recordCount,
    ids,
  } = useEntity();

  useEffect(() => {
    setEntity("Retailer");
  }, []);

  useEffect(() => {
    if (!entityName) return;
    getPage(pageNumber, recordsPerPage, filter);
  }, [entityName, pageNumber, recordsPerPage, filter]);

  useEffect(() => {}, [entityList]);

  const handleSearch = async () => {
    if (pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    await getPage(0, recordsPerPage, filter);
  };

  const handleClearFilter = async () => {
    setFilter(null);

    if (pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    await getPage(0, recordsPerPage, null);
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  const handlePageChange = (newPage) => {
    setPageNumber(newPage);
  };

  const handleRecordsPerPageChange = (newRecordsPerPage) => {
    setRecordsPerPage(newRecordsPerPage);
  };

  const handleToolbarItemClick = (item) => {
    switch (item) {
      case "add":
        setOpenRetailerModal(true);
        break;
    }
  };

  const handleCloseModals = () => {
    setOpenRetailerModal(false);
  };

  const handleRowClick = (column, id) => {
    if (!id) return;

    navigate("/retailer", { state: { retailerId: id } });
  };

  const handleSave = async () => {
    handleCloseModals();
    await handleClearFilter();
  };

  return (
    <>
      <Page
        pageName="retailers"
        onToolItemClick={handleToolbarItemClick}
        includeToolbar
        items={[{ name: "add", iconName: "AddCircleOutline" }]}
      >
        <Filter
          fields={["search", "includeInactiveRetailers"]}
          filter={filter}
          onFilterChange={(newValue) => handleFilterChange(newValue)}
          onSearch={handleSearch}
          onClear={handleClearFilter}
        />

        <Pagination
          totalCount={recordCount}
          styles={{ marginTop: "5px" }}
          pageNumber={pageNumber}
          recordsPerPage={recordsPerPage}
          onPageChange={handlePageChange}
          onRecordsPerPageChange={handleRecordsPerPageChange}
        />

        <EntityList
          entityList={entityList}
          entitySchema={entitySchema}
          onRowClick={handleRowClick}
          columns={[{ name: "name", clickable: true }]}
        />
      </Page>

      <RetailerModal
        open={openRetailerModal}
        onClose={handleCloseModals}
        onSave={handleSave}
      />
    </>
  );
};

export default Retailers;
